import axios from "../axios-control";

export const todos = () => axios
    .get('/grupos')
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const cargaUno = id => axios
    .get(`/grupos/${id}`)
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const actualiza = tipo => axios
    .put(`/grupos/${tipo.id}`, tipo)
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const crea = tipo => axios
    .post(`/grupos`, tipo)
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });

export const eliminar = tipo => axios
    .delete(`/grupos/${tipo.id}`)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });